module.exports = __webpack_public_path__ + "f0745fe40ae0efaff2a40bdf880dbb24.fbx";